export function useOrganizationTreeModal() {
  const isOpen = ref(false)

  function openTreeModal(): void {
    isOpen.value = true
  }

  function closeTreeModal(): void {
    isOpen.value = false
  }

  return {
    isOpen,
    openTreeModal,
    closeTreeModal,
  }
}
